import { render, staticRenderFns } from "./EmployeeEditor.html?vue&type=template&id=b4428998&scoped=true&external"
import script from "./EmployeeEditor.vue?vue&type=script&lang=js"
export * from "./EmployeeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4428998",
  null
  
)

export default component.exports